// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__QNYqE","loaderinner":"style_loaderinner__u2Db-"};